import * as React from 'react';

function SvgPropertySigned(props) {
  return (
    <svg width={14} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.25.969H12.16a.497.497 0 00-.393.19L5.324 9.32 2.235 5.406a.5.5 0 00-.392-.19H.75a.125.125 0 00-.099.201l4.28 5.422c.2.253.584.253.786 0l7.631-9.67a.124.124 0 00-.098-.2z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgPropertySigned;
